import myApp from '../../core/infrastructure/firebaseConfig';
import "firebase/compat/auth";

export function logout () {
  myApp.auth().signOut();
}